export default __webpack_public_path__ + "static/images/Chaeyoung_1_thumb.png";